import { useQuery } from '@tanstack/react-query';
import { fetchWorkOrder } from "./endpoints";
export const useWorkOrder = (workOrderId) => {
    var _a, _b, _c;
    const { data: workOrder, isLoading, isFetching, isError, error, } = useQuery({
        queryKey: ['workorder', workOrderId],
        queryFn: () => fetchWorkOrder(workOrderId),
        enabled: !!workOrderId,
    });
    const workOrderErrorMessage = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.title) || '';
    return {
        workOrder,
        isLoading,
        isFetching,
        isError,
        workOrderErrorMessage,
    };
};
